import {mixins, Pie} from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels';


export default {
    extends: Pie,
    mixins: [mixins.reactiveProp],
    props: ['chartData'],
    mounted() {
        this.addPlugin(ChartDataLabels)
        this.renderChart(
            this.chartData,
            {
                plugins: {
                    datalabels: {
                        anchor: 'end',
                        clamp: true,
                        align: 'top',
                        color: '#555',
                        backgroundColor: "#ddd",
                        font: {
                            size: 16,
                        },
                        padding: {
                            top: 5,
                            left: 7,
                            right: 7,
                            bottom: 5
                        },
                        formatter: function(value, context) {
                            if (value === 0) { return null }
                            return `${context.chart.data.labels[context.dataIndex]}: ${value}`;
                        }
                    }
                },
                legend: {
                    display: false
                },
                layout: {
                    padding: 20
                },
                maintainAspectRatio: false
            }
        );
    }
}